import { agingService } from '../../helpers/services/aging.service'
import { sharedHelper } from '@/utils'

export const state = {
  list: { data: [], pagination: { pageNumber: 0, pageSize: 0, lastPage: 0, tableRowsCount: 0 } },
  status: { list: true },
}

export const AGING_MODULE = 'aging'

export const GET_AGING = 'getAging'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const LIST_SUCCESS = 'listSuccess'

function mapRow(item) {
  return {
    debtorCode: item.account_no,
    debtorName: item.company_name,
    current30: Number(item.current_30) || 0,
    days31_60: Number(item.days_31_60) || 0,
    days61_90: Number(item.days_61_90) || 0,
    over90: Number(item.over_90) || 0,
    totalOutstanding: Number(item.total_outstanding) || 0,
    creditLimit: Number(item.credit_limit) || 0,
    agingPercentage: Number(item.aging_percentage) || 0,
    lastPaymentDate: item.last_payment_date,
    displayTerm: item.display_term,
  }
}

export const actions = {
  [GET_AGING]({ commit }, { filter }) {
    commit(REQUESTING, 'list')
    agingService.getAging(filter).then((r) => {
      commit(LIST_SUCCESS, r); commit(SUCCESS)
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
}

export const mutations = {
  [LIST_SUCCESS](state, data) {
    const items = data.data || []
    state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)
    state.list.data = data.success ? items.map(mapRow) : items
  },
  [FAILURE](state) { state.status = { list: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true } },
}
